import { render } from "./IntegrationView.vue?vue&type=template&id=20c667ae&scoped=true"
import script from "./IntegrationView.vue?vue&type=script&lang=js"
export * from "./IntegrationView.vue?vue&type=script&lang=js"

import "./IntegrationView.vue?vue&type=style&index=0&id=20c667ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20c667ae"]])

export default __exports__